module.exports = __webpack_public_path__ + "static/media/fylkir.2850df2f.svg";